import http from "../../http-common";

class NewsArticlesRightSideRelatedEventsService {
    getNewsArticlesRightSideRelatedEventsService(productPath: string) {
        return http.get(`/right-side-section/news-articles/related-events?nodeName=${productPath}`);
    }
}

export default new NewsArticlesRightSideRelatedEventsService();
